export default __webpack_public_path__ + "static/media/file-input.faf38661.svg";